import React, { useState } from 'react';
import { ADSBPositions } from '../../contexts/ADSBContext/models';
import styles from './index.module.scss';

const { modal } = styles;

interface PlaneInfoModalProps {
    planeInfo: ADSBPositions;
}

function PlaneInfoModal({ planeInfo } : PlaneInfoModalProps) {
  const { label, extendedLabel } = planeInfo.viewData ?? {};
  const [visiblePlaneInfo, setVisiblePlaneInfo] = useState(label);

  const handleMouseLeave = () => setVisiblePlaneInfo(label);
  const handleMouseOver = () => setVisiblePlaneInfo(extendedLabel || label);

  return (
    <div
      role="textbox"
      tabIndex={0}
      onMouseLeave={handleMouseLeave}
      onMouseOver={handleMouseOver}
      onFocus={handleMouseOver}
      aria-label="Plane Information"
      className={modal}
    >
      {visiblePlaneInfo ? visiblePlaneInfo.split(',')
        .map((line) => (
          <React.Fragment key={line}>
            {line}
            <br />
          </React.Fragment>
        )) : ''}
    </div>
  );
}

export default PlaneInfoModal;
